<template>
    <div class="header-content d-flex">
        <div class="header-content-left">
            <a href="/" class="header-logo">
                <img src="/img/header/logo.png" alt="HEB.com" />
            </a>
            <div class="ml-3 secure-checkout">
                Secure Checkout
            </div>
        </div>
        <div class="header-content-right d-none d-md-flex">
            <div class="mr-4 secure-contact">
                <strong>We're here to help</strong>
                <br/>
                Call us: <a href="tel:18558030611">1&#8209;855&#8209;803&#8209;0611</a>
            </div>
            <a href="/cart" class="header-cart">
                <span class="fa fa-shopping-cart" aria-hidden="true"></span>
                <span class="cart-item-amount">{{ $store.state.cart.totalCommerceItemCount }}</span>
            </a>
        </div>
    </div>
</template>
<script>
export default {
  name: 'CheckoutHeader',
  data () {
    return {

    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/lib";

    .header-content {
        justify-content: space-between;
        max-height: 98px;
        height: 100%;
        width: 100%;
        background-color: $color-text-white;
        padding: 16px;
        top: 0;
        border-bottom: 1px solid #CCCCCC;
    }

    .header-content-left, .header-content-right {
        display: flex;
        align-items: center;
    }

    .header-logo {
        display: block;
        img {
            height: 100%;
            width: 62px;
            display: block;
        }
    }

    .header-cart {
        position: relative;
        font-size: 45px;
    }

    .secure-checkout {
        color: $color-text-dark;
        font-size: 16px;
        font-weight: $font-weight-bold;
        line-height: 24px;
    }

    .secure-contact {
        font-size: 14px;
        color: $color-text-dark;
    }

    .cart-item-amount {
        background-color: #F8C01B;
        border: 2px solid #FFFFFF;
        border-radius: 50%;
        height: 24px;
        width: 24px;
        position: absolute;
        right: -12px;
        top: 8px;
        font-size: 12px;
        color: $color-text-dark;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    @media screen and (min-width: $breakpoint-tablet){
        .header-content {
            padding: 0 95px;
        }

        .header-logo {
            img {
                height: 56px;
                width: 100%;
            }
        }

        .secure-checkout {
            font-size: 18px;
        }
    }
</style>

<docs>
    The Vue component for checkout header

    ```jsx
        <checkout-header></checkout-header>
    ```

    The checkout header will only display on the checkout page and will show that the user is on a secure checkout page
</docs>
